module.exports = __webpack_public_path__ + "img/20coin@2x.ab503e13.png";